import React from 'react';
import { assetUrl } from '../../utils/assets';

/* ── Generic line icons ───────────────────────────────────────────
   Carry no brand, so they take the site palette via CSS (stroke set on
   .sv-tile svg). Brand marks are never drawn here; see <Mark>. */
const svg = (children) => () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">{children}</svg>
);

export const Icon = {
  Search:   svg(<><circle cx="11" cy="11" r="7" /><line x1="20" y1="20" x2="16.2" y2="16.2" /></>),
  Grid:     svg(<><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>),
  Mail:     svg(<><rect x="3" y="5" width="18" height="14" rx="2" /><polyline points="3 7 12 13 21 7" /></>),
  Star:     svg(<polygon points="12 3 14.8 8.6 21 9.5 16.5 13.8 17.6 20 12 17.1 6.4 20 7.5 13.8 3 9.5 9.2 8.6" />),
  Pen:      svg(<><path d="M4 20l4-1 11-11-3-3L5 16z" /><line x1="13" y1="6" x2="18" y2="11" /></>),
  Code:     svg(<><polyline points="8 7 3 12 8 17" /><polyline points="16 7 21 12 16 17" /></>),
  Rocket:   svg(<><path d="M12 3c3 2 5 6 5 10l-2 2H9l-2-2c0-4 2-8 5-10z" /><path d="M9 15l-3 3 1-4M15 15l3 3-1-4" /><circle cx="12" cy="10" r="1.5" /></>),
  Doc:      svg(<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><polyline points="14 3 14 9 20 9" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" /></>),
  Check:    svg(<><circle cx="12" cy="12" r="9" /><polyline points="8 12.5 11 15.5 16 9.5" /></>),
  Calendar: svg(<><rect x="3" y="5" width="18" height="16" rx="2" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="8" y1="3" x2="8" y2="7" /><line x1="16" y1="3" x2="16" y2="7" /><polyline points="9 15.5 11.2 17.5 15 13.5" /></>),
  Phone:    svg(<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1A19.5 19.5 0 0 1 4.7 12a19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7.9 8.9a16 16 0 0 0 6 6l.8-.8a2 2 0 0 1 2.1-.4c.9.3 1.9.6 2.8.7a2 2 0 0 1 1.7 2z" />),
  Wave:     svg(<><line x1="4" y1="10" x2="4" y2="14" /><line x1="8" y1="7" x2="8" y2="17" /><line x1="12" y1="4" x2="12" y2="20" /><line x1="16" y1="7" x2="16" y2="17" /><line x1="20" y1="10" x2="20" y2="14" /></>),
  Keypad:   svg(<><circle cx="7" cy="6" r="1.4" /><circle cx="12" cy="6" r="1.4" /><circle cx="17" cy="6" r="1.4" /><circle cx="7" cy="12" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="17" cy="12" r="1.4" /><circle cx="7" cy="18" r="1.4" /><circle cx="12" cy="18" r="1.4" /><circle cx="17" cy="18" r="1.4" /></>),
  Hook:     svg(<><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></>),
  Transfer: svg(<><polyline points="17 4 21 8 17 12" /><line x1="3" y1="8" x2="21" y2="8" /><polyline points="7 12 3 16 7 20" /><line x1="21" y1="16" x2="3" y2="16" /></>),
  Chat:     svg(<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />),
  Tape:     svg(<><circle cx="7" cy="12" r="3.5" /><circle cx="17" cy="12" r="3.5" /><line x1="7" y1="15.5" x2="17" y2="15.5" /></>),
  Record:   svg(<><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3.5" /></>),
  Upload:   svg(<><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /><polyline points="8 8 12 4 16 8" /><line x1="12" y1="4" x2="12" y2="15" /></>),
  Qr:       svg(<><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><line x1="14" y1="14" x2="14" y2="17" /><line x1="17" y1="14" x2="21" y2="14" /><line x1="21" y1="17" x2="21" y2="21" /><line x1="14" y1="21" x2="18" y2="21" /></>),
  Queue:    svg(<><circle cx="9" cy="8" r="3.2" /><path d="M3 20v-1.5a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5V20" /><circle cx="17" cy="9" r="2.4" /><path d="M21 20v-1.2a4 4 0 0 0-3-3.9" /></>),
  Tablet:   svg(<><rect x="4" y="2.5" width="16" height="19" rx="2" /><line x1="10" y1="18.5" x2="14" y2="18.5" /></>),
  Pos:      svg(<><rect x="3" y="6" width="18" height="12" rx="2" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="7" y1="14.5" x2="10" y2="14.5" /></>),
  Bell:     svg(<><path d="M5 17V12a7 7 0 0 1 14 0v5" /><line x1="3" y1="17" x2="21" y2="17" /><line x1="12" y1="3" x2="12" y2="5" /></>),
  Globe:    svg(<><circle cx="12" cy="12" r="9" /><line x1="3" y1="12" x2="21" y2="12" /><path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>),
  Mobile:   svg(<><rect x="7" y="2.5" width="10" height="19" rx="2" /><line x1="11" y1="18.5" x2="13" y2="18.5" /></>),
  Server:   svg(<><rect x="3" y="4" width="18" height="6" rx="1.5" /><rect x="3" y="14" width="18" height="6" rx="1.5" /><circle cx="7" cy="7" r="0.9" /><circle cx="7" cy="17" r="0.9" /></>),
  Cloud:    svg(<path d="M7 18a4 4 0 0 1-.6-8 5.5 5.5 0 0 1 10.6-1.5A4 4 0 0 1 17 18z" />),
  Shield:   svg(<><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z" /><polyline points="9 12 11 14 15 10" /></>),
  Cart:     svg(<><circle cx="9" cy="20" r="1.3" /><circle cx="17" cy="20" r="1.3" /><path d="M3 4h2l2.4 11h10.4L20 8H6.2" /></>),
  Layers:   svg(<><polygon points="12 3 21 8 12 13 3 8" /><polyline points="3 12 12 17 21 12" /><polyline points="3 16 12 21 21 16" /></>),
  Timer:    svg(<><circle cx="12" cy="13" r="8" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="13" x2="15" y2="15" /><line x1="9" y1="2.5" x2="15" y2="2.5" /></>),
  Eye:      svg(<><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" /><circle cx="12" cy="12" r="3" /></>),
};

/* ── Brand mark ───────────────────────────────────────────────────
   Rendered as an untouched <img>. `light` places it on a bone chip, for
   marks whose official artwork is black/dark and would vanish on the
   page's dark ground. Nothing is ever recoloured. `wide` widens the
   allowance for wordmark-shaped logos. */
export const Mark = ({ src, alt, light, wide }) => (
  <span className={`sv-mark${light ? ' sv-mark--light' : ''}${wide ? ' sv-mark--wide' : ''}`}>
    <img src={assetUrl(src)} alt={alt} />
  </span>
);

/* ── Flow diagram ─────────────────────────────────────────────────
   steps: [{ label, icon }]. Horizontal on desktop, vertical on phones.
   Every step shares one tile geometry so labels sit on one baseline. */
export const Flow = ({ steps, stage }) => (
  <div className="sv-flow-wrap">
    {stage && <div className="sv-flow-stage">{stage}</div>}
    <div className="sv-flow" role="list">
      {steps.map((step, i) => (
        <React.Fragment key={step.label}>
          {i > 0 && <span className="sv-flow-link" aria-hidden="true" />}
          <div className="sv-flow-step" role="listitem">
            <div className="sv-tile">{step.icon}</div>
            <span className="sv-flow-label">{step.label}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
);

/* ── Logo strip ("runs on") ───────────────────────────────────── */
export const MarkStrip = ({ caption, marks }) => (
  <div className="sv-strip">
    {caption && <div className="sv-strip-cap">{caption}</div>}
    <div className="sv-strip-row">
      {marks.map((m) => (
        <div className="sv-strip-item" key={m.alt}>
          {m.node}
          <span className="sv-strip-label">{m.label || m.alt}</span>
        </div>
      ))}
    </div>
  </div>
);

/* ── Capability grid ──────────────────────────────────────────── */
export const CapGrid = ({ items }) => (
  <ul className="sv-caps">
    {items.map((c) => (
      <li className="sv-cap" key={c.title}>
        <div className="sv-cap-icon">{c.icon}</div>
        <div>
          <div className="sv-cap-title">{c.title}</div>
          <div className="sv-cap-desc">{c.desc}</div>
        </div>
      </li>
    ))}
  </ul>
);
